export const add0 = (val, leng) => {
  while (val.length < leng) {
    val = "0" + val;
  }
  return val;
};
